export namespace common {
  export const SYSTEM_NAME = 'SPWS'
}

export namespace userType {
  export const USER_TYPE_NONE = null
  export const USER_TYPE_OPERATION = 1
  export const USER_TYPE_ADMIN = 2
  export const USER_TYPE_FARM_ADMIN = 3
  export const USER_TYPE_FARM_WORKER = 4
  export const USER_TYPE_VIEWER = 5
  export const USER_TYPE_ALL_VIEWER = 6
}
export namespace plantingType {
  export const PLANTING_TYPE_SOWING = 1
  export const PLANTING_TYPE_TRANSPLANT = 2
}

export namespace routerPath {
  export const PATH_LOGIN = '/login'
  export const PATH_PASSWORD_REMINDER = '/password-reminder'
  export const PATH_PASSWORD_REMINDER_COMPLETE = '/password-reminder/complete'
  export const PATH_PASSWORD_RESETTING = '/password-reminder/:uq_key'
  export const PATH_PASSWORD_RESETTING_COMPLETE = '/password-resetting/complete'
  export const PATH_FIELD = '/field'
  export const PATH_FIELD_DETAILS = '/field/:field_id'
  export const PATH_FIELD_ORDER = '/field/order'
  export const PATH_MASTER = '/master'
  export const PATH_ACCOUNT_LIST = '/master/user'
  export const PATH_ACCOUNT_CREATE = '/master/user/create'
  export const PATH_ACCOUNT_EDIT = '/master/user/:user_id'
  export const PATH_GROUP_LIST = '/master/group'
  export const PATH_GROUP_CREATE = '/master/group/create'
  export const PATH_GROUP_EDIT = '/master/group/:group_id'
  export const PATH_AREA_LIST = '/master/area'
  export const PATH_AREA_CREATE = '/master/area/create'
  export const PATH_AREA_EDIT = '/master/area/:area_id'
  export const PATH_DISTRICT_LIST = '/master/district'
  export const PATH_DISTRICT_CREATE = '/master/district/create'
  export const PATH_DISTRICT_EDIT = '/master/district/:district_id'
  export const PATH_RISK_LIST = '/master/risk'
  export const PATH_RISK_CREATE = '/master/risk/create'
  export const PATH_RISK_EDIT = '/master/risk/:risk_id'
  export const PATH_VARIETY_LIST = '/master/variety'
  export const PATH_VARIETY_CREATE = '/master/variety/create'
  export const PATH_VARIETY_EDIT = '/master/variety/:variety_id'
  export const PATH_MASTER_FIELD_LIST = '/master/field'
  export const PATH_MASTER_FIELD_CREATE = '/master/field/create'
  export const PATH_MASTER_FIELD_EDIT = '/master/field/:field_id'
  export const PATH_PLANT_LIST = '/plant'
  export const PATH_PLANT_CREATE = '/plant/create'
  export const PATH_PLANT_EDIT = '/plant/:plant_id'
  export const PATH_PROFIT = '/profit'
  export const PATH_MY_PAGE = '/mypage'
  export const PATH_ERROR_PAGE = '/error-page'
  export const PATH_SP_LOGIN = '/sp/login'
  export const PATH_SP_FIELD = '/sp/field'
  export const PATH_SP_DETAILS = '/sp/field/:field_id/:plant_id'
  export const PATH_SP_RECORD = '/sp/field/:field_id/:plant_id/record/:record_date'
  export const PATH_SP_RECORD_CREATE = '/sp/field/:field_id/:plant_id/record/create'
  export const PATH_SP_RECORD_EDIT = '/sp/field/:field_id/:plant_id/record/:record_date/edit'
  export const PATH_SP_ERROR_PAGE = '/sp/error-page'
  export const PATH_NEWS_BOARD = '/news-board'
  export const PATH_NEWS_BOARD_CREATE = '/news-board/create'
  export const PATH_NEWS_BOARD_DETAILS = '/news-board/:news_board_id/edit'
  export const PATH_NEWS_BOARD_EDIT = '/news-board/:news_board_id'
  export const PATH_NEWS_CONTENT_CREATE = '/news-board/:news_board_id/content/create'
  export const PATH_NEWS_CONTENT_EDIT = '/news-board/:news_board_id/content/:news_board_content_id'
  export const PATH_EXTERNAL_LINKAGE = '/external-link'
  export const PATH_EXTERNAL_LINKAGE_CREATE = '/external-link/create'
  export const PATH_EXTERNAL_LINKAGE_DETAILS = '/external-link/:external-link_id/edit'
  export const PATH_EXTERNAL_LINKAGE_EDIT = '/external-link/:external-link_id'
  export const PATH_EXTERNAL_LINKAGE_CONTENT_CREATE = '/external-link/:external-link_id/content/create'
  export const PATH_EXTERNAL_LINKAGE_CONTENT_EDIT = '/external-linkage/:external-linkage_id/content/:external-linkage_content_id'
}

export namespace harvestStatus {
  export const NOT_DIRECTED = 0
  export const ON_HOLD = 1
  export const CHANCEL = 2
  export const HARVESTE_INSTRUCTIONS = 3
  export const HARVESTING = 4
  export const HARVESTED = 5
}

export namespace plantingSeason {
  export const MAIN = 1
  export const SECONDARY = 2
}

export namespace errorFlag {
  export const ERROR_FLAG_DEFAULT = 1
  export const ERROR_FLAG_AUTH = 2
  export const ERROR_FLAG_SERVER = 3
}

export namespace fieldDetailsApiFlag {
  export const FLAG_FIELD = 1
  export const FLAG_MYPAGE = 2
  export const FLAG_MODAL = 3
  export const FLAG_FIELD_TARGET = 4 // 圃場一覧のターゲット変更
}
